import React from 'react';
import { PeekPopover, PeekContainedIconButton, PeekTypography } from '@piiqtechnologies/ui-components';
import { usePannellumViewer } from '../../../components/pannellum-viewer/PannellumProvider.js';
import { X } from '@piiqtechnologies/svg-icons';

const EditorTooltip = ({ sx = {}, children, onCloseWarningTooltip }) => {
    const [editingTooltip, setEditingTooltip] = React.useState(true);
    const { getContainer } = usePannellumViewer();
    const pannellumContainer = getContainer();
    const toggleEditingTooltip = () => {
        setEditingTooltip(!editingTooltip);
    };
    const onCloseTooltip = () => {
        toggleEditingTooltip();
        onCloseWarningTooltip && onCloseWarningTooltip();
    };
    return (React.createElement(PeekPopover, { id: "editing-tooltip", "aria-labelledby": "editing-tooltip", sx: { position: "absolute", zIndex: 9999 }, PaperProps: {
            sx: Object.assign({ px: 2, py: 1.5, bottom: 20, left: "20px !important", top: "unset !important", minWidth: 300, overflowX: "unset", overflowY: "unset", background: "linear-gradient(0deg, rgba(4, 210, 198, 0.1), rgba(4, 210, 198, 0.1)), #FFFFFF" }, sx),
        }, container: pannellumContainer.parentElement, open: editingTooltip, onClose: onCloseTooltip },
        React.createElement(PeekContainedIconButton, { onClick: onCloseTooltip, sx: {
                position: "absolute",
                top: -10,
                right: -10,
                backgroundColor: "primary.main",
                ":hover": {
                    backgroundColor: "primary.main",
                },
            } },
            React.createElement(PeekTypography, { color: "text.secondary", variant: "h4", lineHeight: "0" },
                React.createElement(X, { strokeWidth: 4 }))),
        children));
};

export { EditorTooltip, EditorTooltip as default };
